import {
  ErpExtranetShopOrderHistoryQuerySortKeys,
  ExtranetShopOrderStatusEnum,
} from '@pharmac-extranet/extranet-api'
import { cleanQueryParams } from '../../../../features/infinite-query/util/cleanQueryParams'
import { GetExtranetShopOrderParams } from '../ShopOrderHistory'

export const mapShopOrderParamsToQueryParams = (
  searchParams: URLSearchParams
): GetExtranetShopOrderParams => {
  const mappedParams: GetExtranetShopOrderParams = {
    sortKey: (searchParams.get('sortKey') ?? undefined) as
      | ErpExtranetShopOrderHistoryQuerySortKeys
      | undefined,
    sortOrder: (searchParams.get('sortOrder') ?? undefined) as 'asc' | 'desc' | undefined,
    status: (searchParams.getAll('status').length > 0
      ? searchParams.getAll('status')
      : []) as ExtranetShopOrderStatusEnum[],
    buyer: searchParams.get('buyer') ?? undefined,
    orderCreatedAt: searchParams.get('orderCreatedAt') ?? undefined,
    orderNumber: searchParams.get('orderNumber') ?? undefined,
  }

  return cleanQueryParams(mappedParams)
}
